<template>
  <div class="page-container" :style="{ 'color': textColor }">
    <!-- 背景图片层（和其它前台页一样，图来自站点设置） -->
    <div class="background-layer" :style="{ 'background-image': 'url(' + backgroundImageUrl + ')' }"></div>

    <!-- 右上角用户区 -->
    <div class="user-area">
      <div class="user-info-box" v-if="isLoggedIn">
        <div class="user-avatar-wrapper" @click="showDropdown = !showDropdown">
          <el-avatar :size="45" :src="userInfo.face" class="user-avatar" />
          <div class="user-badge">
            <el-icon>
              <StarFilled />
            </el-icon>
          </div>
        </div>
        <transition name="el-zoom-in-top">
          <div v-if="showDropdown" class="user-dropdown-menu">
            <div class="dropdown-header">
              <el-avatar :size="52" :src="userInfo.face" class="dropdown-avatar" />
              <div class="user-details">
                <h3>{{ userInfo.uname }}</h3>
                <p class="user-id">UID: {{ userInfo.mid }}</p>
              </div>
            </div>
            <div class="dropdown-divider"></div>
            <div class="dropdown-item" @click="logout2">
              <el-icon>
                <SwitchButton />
              </el-icon>
              <span>退出登录</span>
            </div>
          </div>
        </transition>
      </div>
      <div class="login-entry" v-else>
        <el-button type="primary" size="small" @click="goToLogin" :icon="User" class="login-button">
          登录
        </el-button>
      </div>
    </div>

    <!-- 导航栏 -->
    <nav class="navbar">
      <ul class="nav-list">
        <li class="nav-item" v-for="item in shownNav" :key="item.path" :class="{ active: isActive(item.path) }">
          <router-link :to="item.path" :style="{ 'background-color': settingData.Navigationcolor || 'rgba(0, 0, 0, 0.7)' }">
            <el-icon :size="18" class="nav-icon">
              <component :is="item.icon" />
            </el-icon>
            <span>{{ item.name }}</span>
          </router-link>
        </li>
      </ul>
    </nav>

    <!-- 主体 -->
    <div class="link-integral-container"
      :style="{ '--theme-color': settingData.color || '#409eff', '--nav-color': settingData.Navigationcolor || 'rgba(0, 0, 0, 0.7)' }">
      <el-card class="main-card" shadow="hover">
        <template #header>
          <div class="header-title">
            <el-icon class="title-icon">
              <Calendar />
            </el-icon>
            <span>直播日历</span>
            <span class="header-sub" v-if="total">一共 {{ total }} 场 · 最早 {{ firstDay }}</span>
          </div>
        </template>

        <!-- 月份条：一次只看一个月，这里选（也可以用滚轮翻） -->
        <div class="month-bar">
          <button class="mb-btn" :disabled="!canPrev" @click="stepMonth(-1)" aria-label="上个月">‹</button>
          <span class="mb-title">
            <em>{{ curMonth ? curMonth.year : '—' }}</em>
            <span>年</span>
            <em>{{ curMonth ? curMonth.month : '—' }}</em>
            <span>月</span>
          </span>
          <el-date-picker v-model="monthPicker" type="month" value-format="YYYY-MM" :clearable="false"
            placeholder="选月份" class="mb-picker" @change="onPickMonth" />
          <button class="mb-btn" :disabled="!canNext" @click="stepMonth(1)" aria-label="下个月">›</button>
          <button class="mb-today" v-if="curMonth && !curMonth.isCurrent" @click="goToday">回到本月</button>
          <span class="mb-count" v-if="monthTotal">这个月 {{ monthTotal }} 场</span>
        </div>

        <!-- 标签筛选 -->
        <div class="tag-bar" v-if="tags.length">
          <span class="tag-bar-label">按标签筛：</span>
          <button class="tag-chip" :class="{ on: !activeTag }" @click="activeTag = ''">全部</button>
          <button v-for="t in tags" :key="t.id" class="tag-chip" :class="{ on: activeTag === t.name }"
            :style="activeTag === t.name ? { backgroundColor: t.color || themeColor, borderColor: t.color || themeColor } : { borderColor: (t.color || themeColor) + '88', color: t.color || themeColor }"
            @click="activeTag = activeTag === t.name ? '' : t.name">
            {{ t.name }}
            <em>{{ countOfTag(t.name) }}</em>
          </button>
          <span class="tag-bar-hint" v-if="activeTag">正在只看「{{ activeTag }}」，再点一下取消</span>
        </div>

        <div class="calendar-wrap" v-loading="loading" @wheel.prevent="onWheel">
          <!-- 一条记录都没有时不显示空状态提示，照样把整月日历画出来（样式跟有记录时完全一样） -->
          <div v-if="curMonth" class="month-card">
            <div class="cal-grid">
              <div v-for="w in weekNames" :key="w" class="cal-week">{{ w }}</div>
              <div v-for="(c, i) in curMonth.cells" :key="i" class="cal-cell"
                :class="{ blank: !c.day, today: c.isToday, has: c.events.length, dim: c.all.length && !c.events.length }"
                :style="cellBg(c)" @click="c.events.length && openDay(c)">
                <template v-if="c.day">
                  <span class="dnum">{{ c.dnum }}</span>
                  <span class="multi" v-if="c.events.length > 1">×{{ c.events.length }}</span>
                  <span class="replay-flag" v-if="c.events.some((e) => e.replay)" title="有录播">▶</span>
                  <div class="mini" v-for="e in c.events.slice(0, 2)" :key="e.id">
                    <span class="mini-tag" :style="{ backgroundColor: colorOf(e.tags[0]) }">{{ e.tags[0] || '直播' }}</span>
                    <span class="txt">{{ e.content }}</span>
                  </div>
                  <div class="more" v-if="c.events.length > 2">还有 {{ c.events.length - 2 }} 场…</div>
                  <!-- 有录播的日子：格子里就能看见视频封面，点封面直接跳过去（点别处还是看当天详情） -->
                  <a v-if="coverOf(c)" class="cell-cover" :href="replayOf(c)" target="_blank" rel="noopener noreferrer"
                    :title="'看录播：' + replayOf(c)" @click.stop>
                    <img :src="coverOf(c)" alt="录播封面" referrerpolicy="no-referrer" loading="lazy" />
                    <span class="play">▶</span>
                  </a>
                </template>
              </div>
            </div>
          </div>

          <div class="cal-foot" v-if="total">
            一共 {{ total }} 场 · 最早 {{ firstDay }}；能翻到 {{ monthRange.minKey }} ~ {{ monthRange.maxKey }}，滚轮也能翻月
          </div>
        </div>
      </el-card>
    </div>

    <!-- 某一天的详情 -->
    <!-- 主题色必须写在这个弹窗上：el-dialog 默认被 teleport 到 body，
         挂在不到 .link-integral-container 上（--theme-color 就取不到了，
         胶囊和序号圆圈会变成透明），所以这里直接把颜色注进去 -->
    <el-dialog v-model="dayDialog" width="600px" class="live-day-dialog" align-center
      :style="{ '--theme-color': settingData.color || '#409eff' }">
      <template #header>
        <div class="dd-head">
          <span class="dd-date">{{ dayDate }}</span>
          <span class="dd-badge">{{ dayEvents.length }} 场</span>
        </div>
      </template>

      <div class="day-list">
        <div v-for="(e, i) in dayEvents" :key="e.id" class="day-item">
          <div class="day-item-head">
            <span class="idx">{{ i + 1 }}</span>
            <span class="tags">
              <el-tag v-for="t in e.tags" :key="t" size="small" effect="dark" round
                :style="{ backgroundColor: colorOf(t), borderColor: colorOf(t) }">{{ t }}</el-tag>
            </span>
            <span class="dd-replay-flag" v-if="e.replay">
              <el-icon><VideoPlay /></el-icon>有录播
            </span>
          </div>

          <p class="day-item-content" v-if="e.content">{{ e.content }}</p>
          <p class="day-item-content muted" v-else>（这场没写内容）</p>

          <!-- 录播封面：格子里那张图，详情里也显示，点一下直接跳视频 -->
          <a v-if="e.cover" class="day-item-cover" :href="e.replay || '#'" target="_blank" rel="noopener noreferrer"
            :title="e.replay ? '看录播' : '录播封面'">
            <img :src="e.cover" alt="录播封面" referrerpolicy="no-referrer" loading="lazy" />
            <span class="cover-play" v-if="e.replay">
              <el-icon><VideoPlay /></el-icon>
              <em>看录播</em>
            </span>
          </a>

          <a v-else-if="e.replay" class="day-item-replay" :href="e.replay" target="_blank" rel="noopener noreferrer">
            <el-icon>
              <VideoPlay />
            </el-icon>
            <span>看录播</span>
          </a>
        </div>
      </div>
      <template #footer>
        <el-button round @click="dayDialog = false">关 闭</el-button>
      </template>
    </el-dialog>

    <!-- 悬浮反馈（跟其它页一样） -->
    <div class="floating-button-container">
      <el-tooltip content="反馈" placement="left">
        <el-button class="floating-button" type="primary" circle :style="{ width: '56px', height: '56px' }" @click="floatingVisible = true">
          <el-icon :size="22">
            <ChatDotRound />
          </el-icon>
        </el-button>
      </el-tooltip>
    </div>

    <el-dialog v-model="floatingVisible" title="问题反馈" width="500px">
      <el-form :model="feedbackForm" label-width="90px">
        <el-form-item label="问题描述" required>
          <el-input v-model="feedbackForm.problemDesc" type="textarea" :rows="4" placeholder="请详细描述你的问题..." />
        </el-form-item>
        <el-form-item label="QQ / 联系方式">
          <el-input v-model="feedbackForm.contactInfo" placeholder="请留下联系方式以便回复" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="floatingVisible = false">取消</el-button>
          <el-button type="primary" @click="submitFeedback">提交反馈</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 备案号：结构跟首页/作品/积分兑换… 一模一样（多套一层 .record-text） -->
    <div class="footer-record">
      <div class="record-text" :style="{ 'color': textColor }">
        <a href="https://beian.miit.gov.cn/" target="_blank" :style="{ 'color': textColor }">
          陕ICP备2025066285号-2
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
/* 直播日历（前台）
 * - 数据来自 /adminapi/live/list（公开接口，一次把全部直播记录 + 标签拿回来，页面自己排）
 * - 范围：最早那场所在月的 1 号 → 今天所在周的下一个周日（主人给的例子：今天 10-14 周三 → 最晚 10-25）
 * - 一天可以有多场，格子上显示「×N」，点开看当天全部
 * - 标签可以直接点着筛；配色走「主页设置」的主题色（setting.color）
 */
import { computed, nextTick, onMounted, onUnmounted, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import { ElMessage } from 'element-plus';
import {
  HomeFilled, Collection, Coin, Present, Headset, InfoFilled, Calendar,
  StarFilled, SwitchButton, User, ChatDotRound
} from '@element-plus/icons-vue';
import { ASSET_BASE } from '../../util/assetBase';

// 背景跟首页/歌单那几个页面保持**完全一致**：同样是「设置里有就用设置的，没有就用这张默认图」，
// 透明度也同样是 .background-layer 的 0.1
const defaultBackground = 'https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg';

const route = useRoute();
const router = useRouter();

const navItems = [
  { path: '/', name: '首页', icon: HomeFilled },
  { path: '/works', name: '作品', icon: Collection },
  { path: '/points', name: '积分兑换', icon: Coin },
  { path: '/captain', name: '舰长礼物', icon: Present },
  { path: '/songlist', name: '歌单', icon: Headset },
  { path: '/livecalendar', name: '直播日历', icon: Calendar },
  { path: '/about', name: '关于', icon: InfoFilled }
];

// 一场直播记录都还没有的时候，导航里的「直播日历」就不出现（后台录一场，它自己就回来）
const liveCount = ref(0);
// 主人要求：直播日历这一项所有域名都显示（原来是「有直播记录才出现」，
// 结果子域名那几个库是空的，整个入口都看不见了）
const shownNav = computed(() => navItems.slice());
axios.get('/adminapi/live/list?_=' + Date.now()).then((r) => { liveCount.value = Number((r.data && r.data.count) || 0); }).catch(() => {});

const isActive = (path) => route.path === path;

/* ---------------- 站点设置 / 登录态 ---------------- */
const settingData = reactive({ nickname: '', color: '#409eff', backcolor: 'rgba(255,255,255,0.9)', Navigationcolor: 'rgba(0,0,0,0.7)', bottomcolor: '#000000' });
const backgroundImageUrl = ref('');
const themeColor = computed(() => settingData.color || '#409eff');

const textColor = computed(() => {
  const color = String(settingData.bottomcolor || '#000000').replace('#', '');
  const r = parseInt(color.substr(0, 2), 16) || 0;
  const g = parseInt(color.substr(2, 2), 16) || 0;
  const b = parseInt(color.substr(4, 2), 16) || 0;
  return (r * 299 + g * 587 + b * 114) / 1000 > 128 ? '#333' : '#fff';
});

const isLoggedIn = ref(false);
const userInfo = reactive({ uname: '', mid: '', face: '' });
const showDropdown = ref(false);

const checkLoginStatus = () => {
  const saved = localStorage.getItem('userInfo');
  if (!saved) return;
  try {
    const p = JSON.parse(saved);
    if (p && p.mid) { Object.assign(userInfo, p); isLoggedIn.value = true; }
  } catch (e) { localStorage.removeItem('userInfo'); }
};
const goToLogin = () => router.push('/userlogin');
const logout2 = () => {
  localStorage.removeItem('userInfo');
  isLoggedIn.value = false;
  userInfo.uname = ''; userInfo.mid = ''; userInfo.face = '';
  showDropdown.value = false;
  ElMessage.success('已退出登录');
};
const handleClickOutside = (e) => {
  const area = document.querySelector('.user-area');
  if (area && !area.contains(e.target)) showDropdown.value = false;
};

const fetchSetting = async () => {
  try {
    const res = await axios.get('/adminapi/setting/list?_=' + Date.now());
    const s = (res.data && res.data.results && res.data.results[0]) || {};
    settingData.nickname = s.title || '';
    settingData.color = s.color || '#409eff';
    settingData.backcolor = s.backcolor || 'rgba(255,255,255,0.9)';
    settingData.Navigationcolor = s.Navigationcolor || 'rgba(0,0,0,0.7)';
    settingData.bottomcolor = s.bottomcolor || '#000000';
    backgroundImageUrl.value = s.page ? ASSET_BASE + s.page : defaultBackground;
  } catch (e) {
    backgroundImageUrl.value = defaultBackground;
  }
};

/* ---------------- 直播日历数据 ---------------- */
const WEEK = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];
const weekNames = WEEK;

const loading = ref(false);
const rawDays = ref([]);
const tags = ref([]);
const activeTag = ref('');
const dayDialog = ref(false);
const dayEvents = ref([]);
const dayTitle = ref('');   // 兼容保留（标题改成自定义头部了）
const dayDate = ref('');

const colorOf = (name) => {
  const t = tags.value.find((x) => x.name === name);
  return (t && t.color) || themeColor.value;
};
const countOfTag = (name) => rawDays.value.filter((d) => (d.tags || []).indexOf(name) >= 0).length;

const total = computed(() => rawDays.value.length);
const firstDay = computed(() => (rawDays.value.length ? rawDays.value[0].day : ''));
const lastDay = computed(() => fmt(nextSunday(new Date())));

/** 日期 → 当天所有场次 */
const byDay = computed(() => {
  const m = {};
  rawDays.value.forEach((d) => { (m[d.day] = m[d.day] || []).push(d); });
  return m;
});
/** 当前筛选后，某天还有哪些场次（筛掉的当天不再高亮） */
const shownOf = (key) => {
  const list = byDay.value[key] || [];
  if (!activeTag.value) return list;
  return list.filter((e) => (e.tags || []).indexOf(activeTag.value) >= 0);
};

const ymd = (d) => [d.getFullYear(), String(d.getMonth() + 1).padStart(2, '0'), String(d.getDate()).padStart(2, '0')].join('-');
const fmt = ymd;
const parseDay = (s) => { const [y, m, d] = String(s).split('-').map(Number); return new Date(y, m - 1, d); };

/** 今天所在周的下一个周日（今天 10-14 周三 → 10-25） */
function nextSunday(today) {
  const d = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const delta = (7 - d.getDay()) % 7;      // 到本周日还有几天（今天就是周日则 0）
  d.setDate(d.getDate() + delta + 7);      // 再往后一周
  return d;
}

/* 一次只显示一个月：月份可以在上面的月份条里选，也可以滚轮上下滚着翻 */
const todayKey = ymd(new Date());
const thisMonthKey = todayKey.slice(0, 7);
const curKey = ref('');
const monthPicker = ref('');

/** 能翻的范围：最早那场所在的月 → 今天所在周的下个周日所在的月 */
const monthRange = computed(() => {
  const today = new Date();
  const end = nextSunday(today);
  const first = rawDays.value.length ? parseDay(rawDays.value[0].day) : new Date(today.getFullYear(), today.getMonth(), 1);
  const pad = (n) => String(n).padStart(2, '0');
  return {
    minKey: first.getFullYear() + '-' + pad(first.getMonth() + 1),
    maxKey: end.getFullYear() + '-' + pad(end.getMonth() + 1)
  };
});

const keyAdd = (key, delta) => {
  const [y, m] = String(key).split('-').map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
};
const canPrev = computed(() => !!curKey.value && curKey.value > monthRange.value.minKey);
const canNext = computed(() => !!curKey.value && curKey.value < monthRange.value.maxKey);

/** 当前这个月的格子 */
const curMonth = computed(() => {
  const key = curKey.value;
  if (!key) return null;
  const [y, mo] = key.split('-').map(Number);
  const m0 = mo - 1;
  const daysInMonth = new Date(y, mo, 0).getDate();
  const lead = (new Date(y, m0, 1).getDay() + 6) % 7;    // 周一放第一列
  const cells = [];
  for (let i = 0; i < lead; i++) cells.push({ day: '', all: [], events: [] });
  let cnt = 0;
  for (let d = 1; d <= daysInMonth; d++) {
    const k = ymd(new Date(y, m0, d));
    const all = byDay.value[k] || [];
    const events = shownOf(k);
    if (events.length) cnt += events.length;
    cells.push({ day: k, dnum: d, isToday: k === todayKey, all: all, events: events });
  }
  while (cells.length % 7 !== 0) cells.push({ day: '', all: [], events: [] });
  return { key: key, year: y, month: mo, cells: cells, total: cnt, isCurrent: key === thisMonthKey };
});
const monthTotal = computed(() => (curMonth.value ? curMonth.value.total : 0));

const setMonth = (key) => {
  if (!key) return;
  const { minKey, maxKey } = monthRange.value;
  const k = key < minKey ? minKey : (key > maxKey ? maxKey : key);
  curKey.value = k;
  monthPicker.value = k;
};
const stepMonth = (d) => setMonth(keyAdd(curKey.value || thisMonthKey, d));
const goToday = () => setMonth(thisMonthKey);
const onPickMonth = (v) => setMonth(v);

/** 滚轮翻月（节流 320ms，不然一格滚轮能飞好几个月） */
let wheelLock = 0;
const onWheel = (e) => {
  const now = Date.now();
  if (now - wheelLock < 320) return;
  wheelLock = now;
  stepMonth(e.deltaY > 0 ? 1 : -1);
};

/** #rrggbb + 透明度 → rgba，用来做「标签色的半透明底」 */
const withAlpha = (hex, a) => {
  const h = String(hex || '').replace('#', '');
  if (h.length !== 6) return 'rgba(255,255,255,' + a + ')';
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
};

/** 这一天的格子底色 = 当天直播标签的颜色（半透明）。
 *  一天多个标签就斜着拼成渐变；没标签就用主题色兜底。 */
const cellBg = (c) => {
  const evs = c.events || [];
  if (!evs.length) return {};
  const colors = [];
  evs.forEach((e) => (e.tags || []).forEach((t) => {
    const col = colorOf(t);
    if (col && colors.indexOf(col) < 0) colors.push(col);
  }));
  if (!colors.length) return { background: withAlpha(themeColor.value, 0.34) };
  if (colors.length === 1) return { background: withAlpha(colors[0], 0.34) };
  const n = colors.length;
  const stops = colors.map((col, i) => withAlpha(col, 0.32) + ' ' + Math.round((i * 100) / n) + '% ' + Math.round(((i + 1) * 100) / n) + '%');
  return { background: 'linear-gradient(135deg, ' + stops.join(', ') + ')' };
};

/** 当天有录播的那一场（可能有多场，取第一条带封面的） */
const coverEvent = (c) => (c.events || []).find((e) => e.cover && e.replay) || null;
const coverOf = (c) => { const e = coverEvent(c); return e ? e.cover : ''; };
const replayOf = (c) => { const e = coverEvent(c); return e ? e.replay : '#'; };

const openDay = (cell) => {
  dayEvents.value = cell.events;
  dayDate.value = cell.day;
  dayTitle.value = cell.day + ' 的直播（' + cell.events.length + ' 场）';
  dayDialog.value = true;
};

const loadLive = async () => {
  loading.value = true;
  try {
    const res = await axios.get('/adminapi/live/list?_=' + Date.now());
    const d = res.data || {};
    rawDays.value = d.days || [];
    tags.value = d.tags || [];
    setMonth(curKey.value || thisMonthKey);
  } catch (e) {
    ElMessage.error('直播日历加载失败：' + (e.response?.data?.message || e.message));
  } finally {
    loading.value = false;
  }
};

/* ---------------- 反馈（跟其它页一个样） ---------------- */
const floatingVisible = ref(false);
const feedbackForm = reactive({ problemDesc: '', contactInfo: '' });
const submitFeedback = async () => {
  if (!feedbackForm.problemDesc.trim()) { ElMessage.warning('请先描述一下问题'); return; }
  try {
    const fd = new FormData();
    fd.append('problemDesc', feedbackForm.problemDesc);
    fd.append('contactInfo', feedbackForm.contactInfo);
    await axios.post('/adminapi/Feedback/add', fd);
    ElMessage.success('反馈已提交，谢谢！');
    floatingVisible.value = false;
    feedbackForm.problemDesc = '';
    feedbackForm.contactInfo = '';
  } catch (e) {
    ElMessage.error('提交失败：' + (e.response?.data?.message || e.message));
  }
};

onMounted(async () => {
  checkLoginStatus();
  document.addEventListener('click', handleClickOutside);
  // 电脑上直播日历也不许上下滑动（滚动发生在 html/body 上，所以两边都要关）
  // 手机端日历比一屏长，锁住就等于看不到后面的日期，所以只在宽屏锁
  applyPageLock();
  window.addEventListener('resize', applyPageLock);
  await Promise.all([fetchSetting(), loadLive()]);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
  window.removeEventListener('resize', applyPageLock);
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
});

// 手机端（≤768px）不锁滚动
const MOBILE_BREAKPOINT = 768;
const applyPageLock = () => {
  const lock = window.innerWidth > MOBILE_BREAKPOINT;
  document.documentElement.style.overflow = lock ? 'hidden' : '';
  document.body.style.overflow = lock ? 'hidden' : '';
};
</script>

<style lang="scss" scoped>
/* 主人要求直播日历也不许上下滑动：一屏高（含内边距）、不出现滚动条 */
.page-container { box-sizing: border-box; height: 100vh; overflow: hidden; min-height: 100vh; padding: 20px 20px 56px; position: relative; background: none !important; }

.background-layer {
  position: fixed; inset: 0; z-index: -1;
  background-size: cover; background-position: center; background-repeat: no-repeat;
  background-attachment: fixed;
  opacity: 1;                   /* 跟首页一致 —— 首页的 .background-layer 没有设 opacity，就是满不透明 */
}

.user-area { position: absolute; top: 20px; right: 20px; z-index: 100; }
.user-avatar-wrapper { position: relative; cursor: pointer; transition: all .3s ease; }
.user-avatar { border: 2px solid rgba(255,255,255,.8); box-shadow: 0 4px 12px rgba(0,0,0,.15); }
.user-badge { position: absolute; right: -4px; bottom: -4px; background: #ffb800; border-radius: 50%; width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 11px; }
.user-dropdown-menu { position: absolute; right: 0; top: 60px; width: 240px; background: var(--card-bg, rgba(255,255,255,.95)); border-radius: 12px; box-shadow: 0 8px 24px rgba(0,0,0,.15); padding: 14px; }
.dropdown-header { display: flex; gap: 10px; align-items: center; }
.user-details h3 { margin: 0; font-size: 14px; }
.user-details p { margin: 2px 0 0; font-size: 12px; color: #909399; }
.dropdown-divider { height: 1px; background: #ebeef5; margin: 10px 0; }
.dropdown-item { display: flex; align-items: center; gap: 8px; padding: 8px; border-radius: 8px; cursor: pointer; font-size: 13px; }
.dropdown-item:hover { background: #f5f7fa; }

.navbar { position: relative; z-index: 1; margin-bottom: 30px; }
.nav-list { display: flex; justify-content: center; list-style: none; padding: 0; margin: 0; flex-wrap: wrap; gap: 10px; }
.nav-item a {
  color: #fff; text-decoration: none; font-size: 15px; padding: 10px 18px; border-radius: 20px;
  transition: all .3s ease; display: flex; align-items: center; backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,.3);
}
.nav-item a:hover { opacity: .9; transform: translateY(-2px); box-shadow: 0 4px 8px rgba(0,0,0,.2); }
.nav-item a.router-link-active { box-shadow: 0 0 10px rgba(255,255,255,.5); font-weight: bold; }
.nav-icon { margin-right: 8px; }

.link-integral-container { position: relative; z-index: 1; max-width: 1200px; margin: 0 auto; }
/* 主人要求：不要把背景图用白色盖住 —— 卡片整块透明，只有月份卡做一层很浅的玻璃
   （原来 el-card 默认白底，等于给日历垫了一块白板） */
/* 整张卡片（标题 + 统计 + 月份条 + 标签筛选 + 日历）就是那块半透明白底，
   卡片以外的地方透出背景图，没有蒙版 */
/* 卡片外观跟首页那张 100% 对齐：背景 rgba(255,255,255,.85)、1px 白边、20px 圆角
   （首页是 .glass-effect 给的，实测 computed 就是这三个值） */
.main-card {
  box-sizing: border-box;
  width: 100%;
  max-width: 1200px;
  height: 800px;
  margin: 0 auto;
  border-radius: 20px !important;
  overflow: hidden;
  background: rgba(255, 255, 255, .85) !important;
  border: 1px solid rgba(255, 255, 255, .18) !important;
  box-shadow: none !important;
  display: flex;
  flex-direction: column;
}
.main-card :deep(.el-card__header) { border-bottom: none; padding: 14px 22px 0; }
.main-card :deep(.el-card__body) {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 10px 22px 16px;
}
.header-title { display: flex; align-items: center; gap: 8px; font-size: 18px; font-weight: 600; color: var(--theme-color); padding: 6px 0; }
.title-icon { font-size: 20px; }
.header-sub { font-size: 12px; font-weight: 400; color: #909399; margin-left: 6px; }

/* 月份条（在筛选上面）：左右翻月 + 选月份 + 回到本月 */
.month-bar { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; padding: 2px 0 14px; }
/* 月份条：数字、年/月、按钮边框一律用后台设置的主题色（--theme-color 就是 setting.color） */
.mb-btn {
  width: 32px; height: 32px; border-radius: 50%;
  border: 1px solid color-mix(in srgb, var(--theme-color) 65%, transparent);
  background: rgba(0, 0, 0, .26); color: var(--theme-color);
  font-size: 20px; line-height: 1; cursor: pointer; transition: all .2s ease;
  display: inline-flex; align-items: center; justify-content: center;
  text-shadow: 0 2px 8px rgba(0, 0, 0, .6);
}
.mb-btn:hover:not(:disabled) { background: var(--theme-color); border-color: var(--theme-color); color: #fff; transform: translateY(-1px); }
.mb-btn:disabled { opacity: .3; cursor: not-allowed; }
.mb-title { display: flex; align-items: baseline; gap: 3px; text-shadow: 0 2px 8px rgba(0, 0, 0, .6); }
.mb-title em { font-style: normal; font-size: 24px; font-weight: 700; color: var(--theme-color); }
.mb-title span { font-size: 13px; color: var(--theme-color); opacity: .9; }
.mb-picker { width: 118px; }
.mb-today {
  border: 1px solid color-mix(in srgb, var(--theme-color) 65%, transparent);
  background: rgba(0, 0, 0, .26); color: var(--theme-color);
  border-radius: 999px; padding: 5px 12px; font-size: 12px; cursor: pointer; transition: all .2s ease;
}
.mb-today:hover { background: var(--theme-color); border-color: var(--theme-color); color: #fff; }
.mb-count { font-size: 12px; color: var(--theme-color); text-shadow: 0 2px 6px rgba(0, 0, 0, .55); }

/* 标签筛选：也是玻璃片，不垫白底 */
.tag-bar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; padding: 0 0 14px; }
/* 「按标签筛：」用后台设置的主题色 */
.tag-bar-label { font-size: 13px; color: var(--theme-color); text-shadow: 0 2px 6px rgba(0, 0, 0, .55); }
/* 标签按钮的底色 = 导航栏颜色（后台设置里那一项，跟顶部导航链接同色） */
.tag-chip {
  border: 1px solid color-mix(in srgb, var(--theme-color) 55%, transparent);
  background: var(--nav-color); color: #fff;
  border-radius: 999px; padding: 5px 13px; font-size: 13px; cursor: pointer;
  transition: all .2s ease; backdrop-filter: blur(6px); text-shadow: 0 1px 4px rgba(0, 0, 0, .45);
}
.tag-chip:hover { transform: translateY(-1px); }
/* 「全部」被选中时底色 = 后台设置的主题色；其它标签选中时是自己那个颜色（模板里用 inline style 给的） */
.tag-chip.on {
  background: var(--theme-color);
  border-color: var(--theme-color);
  color: #fff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, .3);
}
.tag-chip em { font-style: normal; opacity: .75; margin-left: 4px; font-size: 12px; }
.tag-bar-hint { font-size: 12px; color: rgba(255, 255, 255, .78); }

/* 日历网格自己不再垫底（白底已经在整张卡片上），只负责把剩下的高度撑满 */
.calendar-wrap {
  flex: 1;
  min-height: 0;
  width: 100%;
  padding: 0;
  background: transparent;
  display: flex;
  flex-direction: column;
}
/* 滚轮用来翻月（在 .calendar-wrap 上监听），所以这里不做内部滚动 */

.month-card { border: 0; background: transparent; padding: 0; flex: 1; display: flex; flex-direction: column; }

/* 网格把白底撑满（月份有 5 行也有 6 行，都铺到 900 高） */
/* 第一行是「一 二 三 四 五 六 日」表头 —— 它按内容高度就行，
   别跟着日期格子一起均分（原来一起 1fr，表头那一行被撑得跟日期格一样高，很浪费） */
.cal-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: 55px;      /* 表头行固定 55px */
  grid-auto-rows: 1fr;           /* 其余（日期）行：均分剩下的高度 */
  gap: 6px;
}
/* 表头「星期一…星期日」：55px 高、字大、完整显示（不换行不省略） */
.cal-week {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 55px;
  font-size: 19px;
  font-weight: 600;
  letter-spacing: 1px;
  white-space: nowrap;
  color: #303133;                /* 主人要求：星期一…星期日 用黑色（原来跟主题色） */
}

.cal-cell {
  min-height: 0; border-radius: 12px; padding: 5px 7px;
  background: transparent;
  border: 1px solid color-mix(in srgb, var(--theme-color) 22%, transparent);
  overflow: hidden; position: relative; transition: all .2s ease;
}
.cal-cell.blank { border-color: transparent; }
.cal-cell.has { cursor: pointer; border-color: color-mix(in srgb, var(--theme-color) 55%, transparent); }
.cal-cell.has:hover { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(0, 0, 0, .3); border-color: var(--theme-color); }
.cal-cell.today { border-color: var(--theme-color); box-shadow: inset 0 0 0 1px var(--theme-color); }
.cal-cell.today .dnum { background: var(--theme-color); color: #fff; border-radius: 50%; }
.cal-cell.dim { opacity: .3; }

/* 卡片是白底，日期和内容都用黑字（标签那几颗彩色胶囊保持原样，不动） */
.dnum {
  display: inline-block; min-width: 26px; height: 26px; line-height: 26px; text-align: center;
  font-size: 17px; font-weight: 600; color: #303133;
}
.multi { position: absolute; right: 7px; top: 6px; font-size: 14px; font-weight: 700; color: #303133; }
.mini { display: flex; align-items: center; gap: 5px; margin-top: 5px; font-size: 14px; line-height: 1.4; }
.mini-tag {
  flex-shrink: 0; max-width: 84px; padding: 2px 8px; border-radius: 999px;
  color: #fff; font-size: 13px; text-shadow: 0 1px 3px rgba(0, 0, 0, .5);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.mini .txt { color: #303133; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.more { margin-top: 3px; font-size: 13px; color: #606266; }

.cal-foot { text-align: center; font-size: 12px; color: var(--theme-color); padding: 10px 0 2px; text-shadow: 0 2px 6px rgba(0, 0, 0, .6); }

/* ================= 某一天详情的弹窗（美化） =================
 * 弹窗本体（el-dialog 被 teleport 到 body）的宽度/圆角写在全局 mobile.css 里，
 * 主题色由模板直接注入到 .el-dialog 的行内 style 上。 */
.dd-head { display: flex; align-items: center; gap: 10px; }
.dd-date {
  font-size: 18px; font-weight: 700; color: #303133; letter-spacing: .5px;
  font-variant-numeric: tabular-nums;
}
.dd-badge {
  padding: 2px 10px; border-radius: 999px; font-size: 12px; font-weight: 600; color: #fff;
  background: var(--theme-color);
  box-shadow: 0 2px 8px color-mix(in srgb, var(--theme-color) 45%, transparent);
}

.day-list { max-height: 58vh; overflow-y: auto; padding-right: 4px; }
.day-item {
  padding: 14px 16px; border-radius: 14px; margin-bottom: 12px;
  background: #fff;
  border: 1px solid color-mix(in srgb, var(--theme-color) 20%, #ebeef5);
  box-shadow: 0 2px 10px rgba(0, 0, 0, .05);
  transition: box-shadow .25s ease, transform .25s ease;
}
.day-item:last-child { margin-bottom: 4px; }
.day-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 22px rgba(0, 0, 0, .1);
}

.day-item-head { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; flex-wrap: wrap; }
.day-item-head .idx {
  width: 22px; height: 22px; border-radius: 50%; flex-shrink: 0;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 12px; font-weight: 700; color: #fff;
  background: var(--theme-color);
  box-shadow: 0 2px 6px color-mix(in srgb, var(--theme-color) 40%, transparent);
}
.day-item-head .tags { display: inline-flex; gap: 6px; flex-wrap: wrap; }
.day-item-head .tags :deep(.el-tag) {
  border: none !important;
  text-shadow: 0 1px 3px rgba(0, 0, 0, .35);
  padding: 0 10px;
}
.dd-replay-flag {
  margin-left: auto; display: inline-flex; align-items: center; gap: 3px;
  font-size: 12px; font-weight: 600;
  color: var(--theme-color);
}

.day-item-content {
  margin: 0; font-size: 14px; color: #303133;
  white-space: pre-wrap; word-break: break-word; line-height: 1.75;
}
.day-item-content.muted { color: #c0c4cc; }

/* 录播封面：跟着视频比例走，点一下打开视频；右下角一个「看录播」药丸 */
.day-item-cover {
  position: relative; display: block; margin-top: 12px;
  max-width: 320px; border-radius: 12px; overflow: hidden;
  border: 1px solid rgba(0, 0, 0, .06);
  box-shadow: 0 6px 18px rgba(0, 0, 0, .16);
  line-height: 0;
}
.day-item-cover img { width: 100%; height: auto; display: block; transition: transform .35s ease; }
.day-item-cover:hover img { transform: scale(1.04); }
.cover-play {
  position: absolute; right: 8px; bottom: 8px;
  display: inline-flex; align-items: center; gap: 4px;
  padding: 4px 10px; border-radius: 999px;
  font-size: 12px; font-weight: 600; color: #fff; line-height: 1.4;
  background: rgba(0, 0, 0, .55);
  backdrop-filter: blur(6px);
  transition: background .25s ease;
}
.cover-play em { font-style: normal; }
.day-item-cover:hover .cover-play { background: var(--theme-color); }

.day-item-replay {
  display: inline-flex; align-items: center; gap: 4px; margin-top: 10px;
  padding: 5px 14px; border-radius: 999px;
  font-size: 13px; font-weight: 600;
  color: #fff; background: var(--theme-color); text-decoration: none;
  box-shadow: 0 3px 10px color-mix(in srgb, var(--theme-color) 38%, transparent);
}
.day-item-replay:hover { filter: brightness(1.06); }
.replay-flag { position: absolute; right: 5px; bottom: 3px; font-size: 10px; color: var(--theme-color); }

/* 格子右下角的录播封面：格子里就能看见，点它直接跳视频（点格子别处还是看当天详情） */
.cell-cover {
  position: absolute; right: 5px; bottom: 5px;
  width: 54px; height: 32px; border-radius: 6px; overflow: hidden;
  border: 1px solid rgba(255, 255, 255, .65);
  box-shadow: 0 2px 8px rgba(0, 0, 0, .35);
  display: block;
}
.cell-cover img { width: 100%; height: 100%; object-fit: cover; display: block; }
.cell-cover .play {
  position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
  background: rgba(0, 0, 0, .3); color: #fff; font-size: 11px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, .8); transition: background .2s ease;
}
.cell-cover:hover .play { background: rgba(0, 0, 0, .5); }

.floating-button-container { position: fixed; right: 30px; bottom: 90px; z-index: 99; }
.floating-button { box-shadow: 0 4px 16px rgba(0,0,0,.2); }

/* 备案号样式：跟其它前台页 100% 一致（固定贴底 + 同款毛玻璃底 + 同款 hover） */
.footer-record {
  position: fixed; bottom: 0; left: 0; right: 0;
  text-align: center; z-index: 10; padding: 8px 0;
  backdrop-filter: blur(8px); background-color: rgba(0, 0, 0, .2);
}
.record-text { font-size: 12px; letter-spacing: .5px; }
.record-text a { text-decoration: none; transition: opacity .3s; }
.record-text a:hover { opacity: .8; text-decoration: underline; }

@media (max-width: 768px) {
  /* 手机上日历不再固定 800 高、整页也不锁滚动了：
     原来 page-container 100vh + overflow hidden，日历下半截直接被裁掉且滚不到 */
  .page-container {
    height: auto !important;
    min-height: 100vh !important;
    overflow: visible !important;
    padding: 12px 12px 60px !important;
  }

  .main-card {
    height: auto !important;
    min-height: 0 !important;
    border-radius: 14px !important;
  }
  .main-card :deep(.el-card__header) { padding: 12px 14px 0; }
  .main-card :deep(.el-card__body) { padding: 8px 14px 14px; }
  .header-title { font-size: 16px; }
  .header-sub { display: block; margin-left: 0; font-size: 11px; }

  .month-bar { gap: 8px; padding: 2px 0 10px; }
  .mb-title em { font-size: 20px; }
  .mb-picker { width: 104px; }
  .tag-bar { gap: 6px; padding: 0 0 10px; }
  .tag-chip { padding: 5px 11px; font-size: 12px; }

  /* 关键：7 列在窄屏必须能被压缩（1fr 的 min-content 会把网格撑到 478px 宽，
     星期六/星期日连同后面几列整个跑到屏幕外，卡片还被裁掉） */
  .calendar-wrap { min-width: 0; min-height: 0; }
  .cal-grid {
    min-width: 0;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    grid-template-rows: 55px;
    grid-auto-rows: minmax(46px, 1fr);
    gap: 4px;
  }
  .cal-week { height: 55px; font-size: 13px; letter-spacing: 0; }
  .cal-cell { min-height: 46px; padding: 3px 4px; border-radius: 9px; }
  .dnum { min-width: 22px; height: 22px; line-height: 22px; font-size: 14px; }
  .multi { font-size: 12px; right: 4px; top: 4px; }
  .mini { font-size: 11px; gap: 3px; margin-top: 3px; }
  .mini-tag { max-width: 100%; padding: 1px 6px; font-size: 10px; }
  .mini .txt { display: none; }
  .more { font-size: 10px; }
  .cell-cover { width: 34px; height: 22px; right: 3px; bottom: 3px; }
  .cal-foot { font-size: 11px; padding: 8px 0 2px; }

  /* 某一天详情弹窗（手机） */
  .day-list { max-height: 62vh; padding-right: 0; }
  .day-item { padding: 12px 14px; border-radius: 12px; margin-bottom: 10px; }
  .day-item-head .idx { width: 20px; height: 20px; font-size: 11px; }
  .dd-replay-flag { margin-left: 0; }
  .dd-date { font-size: 16px; }
  .day-item-cover { max-width: 100%; }
  .day-item-content { font-size: 13.5px; }
}
</style>
